'use client';

import {useState} from 'react';
import {closeLine, roadMapFill} from 'src/utils/icons';
import recordEvent from 'src/utils/recordEvent';
import BaseButton from '../BaseButton';

const VisitedMapBanner = () => {
  const [isOpen, setIsOpen] = useState(true);

  if (!isOpen) return null;

  return (
    <section className="absolute max-[800px]:fixed animate-gallery-appear flex flex-col items-start gap-1 bottom-0 left-0 max-[800px]:left-3 right-6 max-[800px]:right-3 p-4 pb-6 pr-10 rounded-t-2xl bg-(--card-color) shadow-big-card">
      <h4 className="font-semibold text-lg">Do you want your own map?</h4>
      <p className="leading-tight max-[800px]:hidden">
        Share where you have been with your own interactive world map. It's quick, fun and free.
      </p>

      <BaseButton
        label="Get my map"
        href="/visited"
        onPress={() => recordEvent('clickedGetMyMap')}
        target="_blank"
        icon={roadMapFill}
        buttonVariant="primary"
        size="small"
        className="mt-4 max-[800px]:mt-2"
      />

      <BaseButton
        icon={closeLine}
        onPress={() => setIsOpen(false)}
        buttonVariant="secondary"
        className="w-[32px] h-[32px] absolute right-4 top-4"
      />
    </section>
  );
};

export default VisitedMapBanner;
